import type { MetadataListItem } from './MetadataSchema'
import { MetadataSchemaInputEnum } from '@ztechapps/common.contract'

/**
 * Whether a row's Value cell is a dropdown. `inputName` keeps the schema's input string beside the
 * resolved component (`useProductMetadata.ts:44-45`), so a select row is detected without reading
 * the runtime component.
 */
export const hasSelectValue = (item?: MetadataListItem): boolean =>
  item?.currentMetadataSchema?.inputName === MetadataSchemaInputEnum.MetadataValueSelect
